import { createSections } from "./create-section";
import "@vetixy/circular-std";

createSections();
